export class ForgottenPasswordRouter {
    
    static getRoute(): string {
        return "/forgotten-password"
    }

}